<template>
  <div>
    <el-tabs v-model="active_top" type="card">
      <el-tab-pane label="功能配置" name="pay">
        <pay-config v-if="active_top == 'pay'"></pay-config>
      </el-tab-pane>
      <el-tab-pane label="积分配置" name="third">
        <integral-config v-if="active_top == 'third'"></integral-config>
      </el-tab-pane>
      <el-tab-pane label="奖品配置" name="four">
        <prize-list v-if="active_top == 'four'"></prize-list>
      </el-tab-pane>
      <el-tab-pane label="佣金流水" name="five">
        <commission-withdrawal
          v-if="active_top == 'five'"
        ></commission-withdrawal>
      </el-tab-pane>
      <el-tab-pane label="积分流水" name="six">
        <score-flow v-if="active_top == 'six'"></score-flow>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import IntegralConfig from "./components/IntegralConfig";
import PrizeList from "./components/PrizeList";
import ScoreFlow from "./components/ScoreFlow";
import CommissionWithdrawal from "./components/CommissionWithdrawal";
import PayConfig from "./components/PayConfig";

export default {
  components: {
    IntegralConfig,
    PrizeList,
    CommissionWithdrawal,
    ScoreFlow,
    PayConfig
  },
  data() {
    return {
      active_top: "pay"
    };
  },
  methods: {}
};
</script>
<style scoped></style>
